<template>
  <div class="machine-group">
    <search-user-machine-labels
      v-on:addUserMachineGroup="addUserMachineGroup"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :search="search"
    >
    </search-user-machine-labels>
    <add-user-machine-labels
      v-on:cancel="cancel"
      :userMachineGroup="userMachineGroup"
      :dialogUserMachineGroup="dialogUserMachineGroup"
    >
    </add-user-machine-labels>
    <advert-group-rela
      :advertGroup="advertGroup"
      :showType="showType"
      v-on:cancelAdvertGroupRela="cancelAdvertGroupRela"
      :dialogAdvertGroupRela="dialogAdvertGroupRela"
      :type="1"
    >
    </advert-group-rela>
    <div class="vue-padding">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="userMachineGroupList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="name"
          :label="$t('common.labelName')"
          :show-overflow-tooltip="true"
          :align="'center'"
        ></el-table-column>
        <el-table-column fixed="right" :label="$t('common.operate')" :width="340" :align="'center'">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="advertConfig(scope.row)">{{
              $t("advertGroup.advertConfig")
            }}</el-button>
            <el-button size="mini" v-hasPerm="['user:machine:group:insert']" @click="editMachineGroup(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delMachineGroup(scope.row)"
              style="padding: 7px"
              >{{ $t("common.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="userMachineGroupList.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchUserMachineLabels from "_c/machine/user/SearchUserMachineLabels";
  import addUserMachineLabels from "_c/machine/user/AddUserMachineLabels";
  import advertGroupRela from "_c/adverts/AdvertGroupRela";

  export default {
    name: "MachineLabels",
    components: {
      addUserMachineLabels,
      searchUserMachineLabels,
      advertGroupRela
    },
    data() {
      return {
        search: {
          teamName: ""
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        userMachineGroupList: [],
        dialogUserMachineGroup: false,
        userMachineGroup: {
          id: "",
          name: "",
          userEquipmentId: []
        },
        loading: false,
        dialogMoveUserMachineGroup: false,
        dialogConfigMachine: false,
        teamId: "",
        dialogAdvertGroupRela: false,
        advertGroup: {
          id: "",
          name: "",
          notes: "",
          display: ""
        },
        showType: []
      };
    },
    mounted() {
      this.currentChange();
      this.listShowType();
    },
    methods: {
      listShowType() {
        this.$api.dict("gp_show_type").then(res => {
          if (res.code === 0) {
            this.showType = res.data;
          }
        });
      },
      advertConfig(row) {
        this.dialogAdvertGroupRela = true;
        Object.keys(this.advertGroup).forEach(key => {
          this.advertGroup[key] = row[key];
        });
        this.advertGroup.id = row.id;
      },
      cancelAdvertGroupRela(dialog) {
        this.dialogAdvertGroupRela = dialog;
      },
      configAdvert(row) {
        console.log(row, 123);
      },
      configCancel(dialog, state) {
        this.dialogConfigMachine = dialog;
        if (state) {
          this.currentChange();
        }
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.UserMachineLabels.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.userMachineGroupList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },

      addUserMachineGroup() {
        this.dialogUserMachineGroup = true;
      },
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      cancel(dialog, state) {
        this.dialogUserMachineGroup = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      editMachineGroup(row) {
        this.dialogUserMachineGroup = true;
        Object.keys(this.userMachineGroup).forEach(key => {
          this.userMachineGroup[key] = row[key];
        });
        this.userMachineGroup.id = row.id;
      },

      delMachineGroup(row) {
        let _self = this;
        _self
          .$confirm(_self.$t("grouptransfer.delwarn"), _self.$t("common.warning"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            _self.$api
              .request(_self.$url.UserMachineLabels.delete, _self.$method.delete, {
                id: row.id
              })
              .then(res => {
                if (res.code === 0) {
                  _self.$notify({
                    title: _self.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  _self.currentChange();
                }
              });
          });
      }
    }
  };
</script>

<style>
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 0 20px;
    height: auto !important;
  }
  .el-dialog__footer {
    padding: 20px;
  }
</style>
